import { api } from "./api";
import { computeTotals, initSelections } from "./calc";
import { generateQuotePdf } from "./pdf";
import { proposalTotalsInput } from "../components/proposal/proposalShared";

async function toDataUrl(url) {
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const r = new FileReader();
      r.onloadend = () => resolve(r.result);
      r.onerror = () => resolve(null);
      r.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
}

async function buildQuotePdf(quoteId, asBlob, logoCache = {}) {
  const { data: quote } = await api.get(`/quotes/${quoteId}/pdf-data`);
  const selections = quote.client_selections || initSelections(quote.items, quote.groups);
  const totals = computeTotals(proposalTotalsInput(quote, selections, quote.applied_promo));
  if (quote.logo_url && !(quote.logo_url in logoCache)) {
    logoCache[quote.logo_url] = await toDataUrl(`${process.env.REACT_APP_BACKEND_URL}${quote.logo_url}`);
  }
  const logo = quote.logo_url ? logoCache[quote.logo_url] : null;
  if (quote.watermark && !("__brand" in logoCache)) {
    logoCache.__brand = await toDataUrl(`${window.location.origin}/logo-header@3x.png`);
  }
  const brandLogo = quote.watermark ? logoCache.__brand : null;
  return { quote, blob: generateQuotePdf({ quote, issuer: quote.issuer, totals, logo, brandLogo, asBlob }) };
}

export async function downloadQuotePdf(quoteId) {
  await buildQuotePdf(quoteId, false);
}

export async function downloadQuotesZip(quoteIds, onProgress) {
  const { default: JSZip } = await import("jszip");
  const zip = new JSZip();
  const used = {};
  const logoCache = {};
  for (let i = 0; i < quoteIds.length; i++) {
    const { quote, blob } = await buildQuotePdf(quoteIds[i], true, logoCache);
    const base = (quote.quote_number || "preventivo").replace(/[\\/:*?"<>|]/g, "-");
    used[base] = (used[base] || 0) + 1;
    zip.file(`${base}${used[base] > 1 ? `-${used[base]}` : ""}.pdf`, blob);
    onProgress?.(i + 1, quoteIds.length);
  }
  const content = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(content);
  const a = document.createElement("a");
  a.href = url;
  a.download = `preventivi-pdf-${new Date().toISOString().slice(0, 10)}.zip`;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadCsv(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
